const state = {
    followingEntries: [],
    featuredEntries: [],
    allEntries: [],
    drafts: [],
    userArtworks: [],
    currentArtwork: [],
    previousArtworks: [],
    nextArtworks: [],
    followingEntriesReachedBottom: false,
    allEntriesReachedBottom: false,
    featuredEntriesReachedBottom: false,
    userEntriesReachedBottom: false,
    userDraftsReachedBottom: false
}

export default state